import type { IToken } from 'chevrotain';
import classNames from 'classnames';
import * as React from 'react';

export interface QueryTokensProps {
  allTokens: IToken[];
  ignoredTokens: IToken[];
  unprocessedTokens: IToken[];
}

const defaultOne = (num: number | undefined) => num ?? 1;

export const QueryTokens: React.VFC<QueryTokensProps> = ({
  allTokens,
  ignoredTokens,
  unprocessedTokens,
}) => {
  const lines: JSX.Element[][] = [[]];
  const ignoredTokensSet = new Set(ignoredTokens);
  const unprocessedTokensSet = new Set(unprocessedTokens);
  const lineOffset = defaultOne(allTokens[0]?.startLine) - 1;
  allTokens.forEach((token, tokenIdx) => {
    const starLineIdx = defaultOne(token.startLine) - 1;
    const newLines = starLineIdx - (lines.length - 1) + lineOffset;
    if (newLines) {
      lines.push(...new Array(Math.max(0, newLines)).fill('').map(() => []));
    }

    const currLineIdx = lines.length - 1;
    const curr = lines[currLineIdx];

    const prevToken = allTokens[tokenIdx - 1];
    if (prevToken) {
      const currStartCol = defaultOne(token.startColumn);
      const prevEndCol = defaultOne(prevToken.endColumn);

      if (prevToken.endLine !== defaultOne(token.startLine)) {
        // new line
        curr.push(
          <span key={`line-${token.startOffset}`}>
            {''.padEnd(currStartCol - 1)}
          </span>
        );
      } else if (prevEndCol !== currStartCol - 1) {
        // whitespace between tokens
        curr.push(
          <span key={`space-${token.startOffset}`}>
            {''.padEnd(currStartCol - 1 - prevEndCol)}
          </span>
        );
      }
    }

    curr.push(
      <span
        key={token.startOffset}
        className={classNames('vb-query-token', {
          'vb-query-token--ignored': ignoredTokensSet.has(token),
          'vb-query-token--unprocessed': unprocessedTokensSet.has(token),
        })}
      >
        {token.image}
      </span>
    );
  });

  return (
    <>
      {lines.map((line, lineIdx) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={lineIdx}>{line}</div>
      ))}
    </>
  );
};
